import React, { useState } from "react";
import "../css/resetPasswordModal.css";

const ResetPasswordModal = ({ isOpen, onClose, onSubmit, isResetDisabled }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordValidations, setPasswordValidations] = useState({
    hasUppercase: false,
    isLongEnough: false,
    hasNumber: false,
  });
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const validatePassword = (password) => {
    setPasswordValidations({
      hasUppercase: /[A-Z]/.test(password) && /[a-z]/.test(password),
      isLongEnough: password.length >= 8,
      hasNumber: /\d/.test(password),
    });
  };

  const handlePasswordChange = (e) => {
    const { value } = e.target;
    setNewPassword(value);
    validatePassword(value);
    setError(""); // Reset error when user types
  };

  const handleConfirmPasswordChange = (e) => {
    const { value } = e.target;
    setConfirmPassword(value);

    // Check if passwords match
    if (newPassword && value && newPassword !== value) {
      setError("Passwords do not match");
    } else {
      setError(""); // Clear error if they match
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      onSubmit(newPassword);
    } else {
      setError("Passwords do not match");
    }
  };

  return (
    <div className="general modal-overlay">
      <div className="modal-content">
        <button className="close-icon" onClick={onClose}>
          ×
        </button>
        <h2>Create new password</h2>
        <p>Enter new password.</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={handlePasswordChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              required
              className={error ? "input-error" : ""}
            />
            {error && <p className="error-message">{error}</p>}
          </div>

          {/* Password Requirements Checklist */}
          <ul className="password-requirements">
            <li className={passwordValidations.hasUppercase ? "valid" : ""}>
              Mix of uppercase & lowercase letters
            </li>
            <li className={passwordValidations.isLongEnough ? "valid" : ""}>
              Minimum 8 characters long
            </li>
            <li className={passwordValidations.hasNumber ? "valid" : ""}>
              Contain at least 1 number
            </li>
          </ul>

          <button
            type="submit"
            className="submit-btn forgot-pass-btn"
            disabled={
              !passwordValidations.hasUppercase ||
              !passwordValidations.isLongEnough ||
              !passwordValidations.hasNumber ||
              !newPassword ||
              !confirmPassword ||
              isResetDisabled
            }
          >
            {isResetDisabled ? "Please wait" : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
